<template>
  <form @submit.prevent="updateSignature()">
    <div class="setting-item">
      <div class="text">
        <h4 class="setting-item__text__title">
          {{ $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.TITLE') }}
        </h4>
        <p class="setting-item__text__help-text">
          {{ $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.NOTE') }}
        </p>
      </div>
      <div class="my-4">
        <label for="message-signature-input">{{
          $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.LABEL')
        }}</label>
        <woot-message-editor
          id="message-signature-input"
          v-model="messageSignature"
          class="message-editor"
          :is-format-mode="true"
          :placeholder="
            $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.PLACEHOLDER')
          "
          @blur="$v.messageSignature.$touch"
        />
      </div>
      <div class="text-end">
        <woot-button
          :is-loading="isUpdating"
          type="submit"
          :is-disabled="$v.messageSignature.$invalid"
        >
          {{ $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.BTN_TEXT') }}
        </woot-button>
      </div>
    </div>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    WootMessageEditor,
  },
  mixins: [alertMixin],
  data() {
    return {
      messageSignature: '',
      enableMessageSignature: false,
      isUpdating: false,
      errorMessage: '',
    };
  },
  validations: {
    messageSignature: {
      required,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentUserId: 'getCurrentUserID',
    }),
  },
  watch: {
    currentUser() {
      this.initValues();
    },
  },
  mounted() {
    this.initValues();
  },
  methods: {
    initValues() {
      const { message_signature: messageSignature } = this.currentUser;
      this.messageSignature = messageSignature || '';
    },
    async updateSignature() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showAlert(this.$t('PROFILE_SETTINGS.FORM.ERROR'), 'error');
        return;
      }
      let alertType;
      try {
        await this.$store.dispatch('updateProfile', {
          message_signature: this.messageSignature,
        });
        this.errorMessage = this.$t(
          'PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.API_SUCCESS'
        );
        alertType = 'success';
      } catch (error) {
        this.errorMessage = this.$t(
          'PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.API_ERROR'
        );
        if (error?.response?.data?.message) {
          this.errorMessage = error.response.data.message;
        }
        alertType = 'error';
      } finally {
        this.isUpdating = false;
        this.showAlert(this.errorMessage, alertType);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-item {
  border: 1px solid var(--b-100);
  padding: 24px 16px;
  border-radius: 16px;
  margin-bottom: 48px;
  &__text {
    &__title {
      color: var(--w-500);
      opacity: 0.5;
      font-weight: 600;
      font-size: 18px;
    }
    &__help-text {
      color: var(--b-900);
      font-size: 14px;
      font-weight: 400;
    }
  }
  .ProseMirror-woot-style {
    height: 8rem;
  }

  .editor-root {
    background: var(--white);
    margin-bottom: var(--space-normal);
  }
}
</style>
